<search
  class="sales-report-search"
  [formGroup]="searchData"
  [isOpen]="!isReady || isOpen"
  [isLoading]="isLoading"
  [showSearchInput]="isReady"
  [showClearButton]="isReady"
  [showCloseButton]="isReady"
  [submitLabel]="isReady
    ? 'cards.products.products_retailer_search.search'
    : 'cards.reports.sales_report_search.hint_action'"
  [submitIcon]="isReady ? 'search-button' : null"
  [submitMinWidth]="isReady ? '156px' : '180px'"
  (onToggle)="toggleOpen($event)"
  [placeholder]="searchPlaceholder"
  (onSubmit)="submit()"
>
  <ng-container panel-left>
    <scope translationsPath="cards.reports.sales_report_search">
      <div class="report-loading-message" *ngIf="isLoading; else searchHint">
        <span class="report-loading-icon" aria-hidden="true">
          <loading-spinner type="transparent" color="tangerine"></loading-spinner>
        </span>
        <p class="report-loading-text">
          <span class="search-hint-emphasis">{{
            'cards.reports.sales_report_search.loading_title' | translate
          }}</span>
          {{ 'cards.reports.sales_report_search.loading_text' | translate }}
        </p>
      </div>

      <ng-template #searchHint>
        <p class="search-hint">
          {{ 'cards.reports.sales_report_search.hint_before' | translate }}
          <span class="search-hint-emphasis">{{
            (isReady
              ? 'cards.products.products_retailer_search.search'
              : 'cards.reports.sales_report_search.hint_action'
            ) | translate
          }}</span>
          {{ 'cards.reports.sales_report_search.hint_after' | translate }}
        </p>
      </ng-template>

      <div class="search-filters" [class.search-filters--disabled]="isLoading">
        <form-field panel label="period" for="from">
          <div any class="period-controls">
            <div class="date-range">
              <lxm-datepicker
                for="from"
                class="f-1"
                placeholder="cards.reports.sales_report_search.date_from"
                [min]="minDate"
                [max]="searchData.get('to').value || maxDate"
                [disabled]="isLoading"
              ></lxm-datepicker>
              <div class="date-range__separator">-</div>
              <lxm-datepicker
                for="to"
                class="f-1"
                placeholder="cards.reports.sales_report_search.date_to"
                [min]="searchData.get('from').value || minDate"
                [max]="maxDate"
                [disabled]="isLoading"
              ></lxm-datepicker>
            </div>

            <div class="period-presets">
              <lxm-button
                type="transparent"
                class="period-preset"
                *ngFor="let days of periodPresets"
                [class.active]="isPeriodPresetActive(days)"
                [label]="'cards.reports.sales_report_search.period_' + days"
                [disabled]="isLoading"
                (click)="applyPeriodPreset(days)"
              ></lxm-button>
            </div>
          </div>
        </form-field>

        <form-field panel label="view" for="viewType" *ngIf="currentReport">
          <combined-toggle-button
            combined
            [readonly]="isLoading"
            [leftToggled]="searchData.get('viewType').value === SalesReportViewType.ProductByDay"
            [rightToggled]="searchData.get('viewType').value === SalesReportViewType.LocationByDay"
            (leftClicked)="setViewType(SalesReportViewType.ProductByDay)"
            (rightClicked)="setViewType(SalesReportViewType.LocationByDay)"
          >
            <span text1>{{ 'cards.reports.sales_report_search.view_by_products' | translate }}</span>
            <span text2>{{ 'cards.reports.sales_report_search.view_by_stores' | translate }}</span>
          </combined-toggle-button>
        </form-field>

        <form-field panel label="show_on_chart" for="fileType">
          <div any class="file-type-options">
            <lxm-button
              type="transparent"
              class="file-type-option"
              *ngFor="let option of fileTypeOptions"
              [class.file-type-option--active]="hasFileType(option.id)"
              [icon]="option.icon"
              [label]="option.name"
              [disabled]="isLoading"
              padding="0 10px 0 8px"
              [attr.aria-pressed]="hasFileType(option.id)"
              (click)="toggleFileType(option.id)"
            ></lxm-button>
          </div>
        </form-field>

        <form-field
          panel
          class="product-field"
          label="product"
          for="product"
          *ngIf="isLocationView"
        >
          <lxm-select
            select
            class="product-select"
            for="product"
            url="api/products/ac/"
            labelField="name"
            [searchable]="true"
            [clearable]="true"
            [acLabelFormat]="productAcLabel"
            [disabled]="isLoading"
            placeholder="cards.reports.sales_report_search.product_placeholder"
          >
          </lxm-select>
        </form-field>
  <!--
        <form-field panel label="inventory_filter" for="inventoryFilter">
          <div any class="segmented">
            <lxm-button
              type="transparent"
              class="segmented__item"
              [active]="searchData.get('inventoryFilter').value === SalesReportInventoryFilter.All"
              [class.active]="searchData.get('inventoryFilter').value === SalesReportInventoryFilter.All"
              label="cards.reports.sales_report_search.inventory_all"
              padding="7px 12px"
              (click)="setInventoryFilter(SalesReportInventoryFilter.All)"
            ></lxm-button>
            <lxm-button
              type="transparent"
              class="segmented__item"
              [active]="searchData.get('inventoryFilter').value === SalesReportInventoryFilter.CriticalOnly"
              [class.active]="searchData.get('inventoryFilter').value === SalesReportInventoryFilter.CriticalOnly"
              label="cards.reports.sales_report_search.inventory_critical"
              padding="7px 12px"
              (click)="setInventoryFilter(SalesReportInventoryFilter.CriticalOnly)"
            ></lxm-button>
          </div>
        </form-field>
  -->
        <form-field
          panel
          class="stores-field"
          label="stores"
          for="locations"
          *ngIf="!isLocationView"
        >
          <lxm-select
            select
            class="stores-select"
            for="locations"
            [options]="locationOptions"
            labelField="name"
            value="id"
            [multiple]="true"
            [searchable]="true"
            [disabled]="isLoading"
            placeholder="cards.reports.sales_report_search.stores_placeholder"
          >
          </lxm-select>
        </form-field>
  <!-- 
        <form-field panel label="price_type" for="priceType">
          <div any class="segmented">
            <lxm-button
              type="transparent"
              class="segmented__item"
              [active]="searchData.get('priceType').value === SalesReportPriceType.Final"
              [class.active]="searchData.get('priceType').value === SalesReportPriceType.Final"
              label="cards.reports.sales_report_search.price_final"
              padding="7px 12px"
              (click)="setPriceType(SalesReportPriceType.Final)"
            ></lxm-button>
            <lxm-button
              type="transparent"
              class="segmented__item"
              [active]="searchData.get('priceType').value === SalesReportPriceType.Purchase"
              [class.active]="searchData.get('priceType').value === SalesReportPriceType.Purchase"
              label="cards.reports.sales_report_search.price_purchase"
              padding="7px 12px"
              (click)="setPriceType(SalesReportPriceType.Purchase)"
            ></lxm-button>
          </div>
        </form-field> -->
      </div>
    </scope>
  </ng-container>
</search>
